exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".stage-one {\n  min-width: 750px; }\n  .stage-one .next {\n    cursor: pointer;\n    float: right;\n    margin-top: 20px;\n    margin-bottom: 25px;\n    user-select: none;\n    width: 150px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/ReportForm/components/StageOne/style.scss
// module id = 1012
// module chunks = 0